export enum EHostType {
  Page = 'page',
  Frame = 'frame',
}
